import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { Text } from 'rebass'
import { RouteComponentProps } from 'react-router-dom'

// utils
import { getCarNFTContract, getCarNFTInfo } from '../../sushi/utils'
import { SortOptions2, AuctionBake } from '../../constants/artwork'
import { MARKETTYPE, NFTTYPE, SUPPORTTYPE, MARKETTYPEV3 } from '../../constants/bakery/nft'

// hooks
import { useActiveWeb3React } from '../../hooks'
import useInterval from '../../hooks/useInterval'
import useYam from '../../hooks/bakery/useYam'
import { BigNumber } from 'bignumber.js'

// components
import Loading from '../../components/Loader/Loading'
import {Artworks} from '../../components/Gamification/Artworks'
import NoArtworks from '../../components/nftInfo/NoArtworks'
import Row from '../../components/Row'
import Paginator from '../../components/Paginator'
import Search from '../Restaurant/components/Search'
import {InfoSolt} from './components/InfoSolt'

import SortPets, { OptionProps } from '../Pet/components/SortPets'
import { getArtworks, getArtworksV2, getArtworksV3 } from '../../service/nft'

import { useMarketLevel } from '../../state/market/hooks'

const PageHead = styled.div`
  display: flex;
  width: 1204px;
  margin: 32px 0 28px;
  justify-content: space-between;
  box-sizing: border-box;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: calc(100% - 40px);
    justify-content: center;
  `}
`
const MyEggs = styled(NavLink)<{bg?: string; border?: string; color?: string}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 174px;
  background: ${({ bg, theme }) => !bg && theme ? theme.primary1 : bg};
  border-radius: 10px;
  color: ${({ color, theme }) => !color && theme ? theme.bsText1 : color};
  font-family: Baloo Da;
  height: 40px;
  text-decoration: none;
  margin-right: 16px;
  border: ${({ border}) => (border ? '1px solid' : '0px solid') + border};
`
const MiniPets = styled.img`
  position: absolute;
  top: -8px;
  left: -9px;
  width: 36px;
  height: auto;
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`
const MyEggsRow = styled(Row)`
  align-items: center;
  flex-shrink: 0;
  width: auto;
  margin-bottom: 10px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    align-items: center;
    &>div{
      margin-bottom: 20px;
    }
    &>a{
      margin-bottom: 20px;
    }
  `}
`

export default function DigitalArtworks({history}: RouteComponentProps<{}>) {
  const level = useMarketLevel()
  const { account, chainId } = useActiveWeb3React()
  const yam = useYam()

  const [loadingFlag, setLoadingFlag] = useState(false)
  const emptyArtworks: any[] = []
  const [artworks, setArtworks] = useState(emptyArtworks)
  let marketType = MARKETTYPEV3.CARNFTV3

  const [page, setPage] = useState(1)
  useEffect(() => {
    setPage(1)
  }, [account, chainId, level])

  const [curValue, setCurValue] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const inputChange = useCallback((e: any) => {
    setCurValue(e.target.value)
  }, [])

  const searchHandle = (value: string) => {
    setSearchValue(value)
    setPage(1)
    if (value === searchValue && page === 1) {
      fetchAsksSort(page, curSelect, searchValue, true)
    }
  }

  const LIMIT = 12
  const [curSelect, setCurSelect] = useState(SortOptions2[0])

  // count
  const [pageCount, setPageCount] = useState(0)
  const fetchAsksSort = async (page: number, rank: OptionProps, searchValue: string, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: 103,
      offset: (page - 1) * LIMIT,
      limit: LIMIT + 1,
      sortName: rank.sortName,
      sortBy: rank.sortBy,
      onSale: 1,
      status: 1,
      keyword: searchValue.trim()
    }

    if (level === 'v1') {
      getArtworks(chainId as number, params, async(err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const artworks = await Promise.all(
          dataAry.map(async(d: any) => {
            let carInfo = {
              lockedCAR: new BigNumber(0),
              stakingPower: new BigNumber(100),
              style: '',
              size: ''
            }
            if (account) {
              carInfo = await getCarNFTInfo(getCarNFTContract(yam), d.nftId)
            }
            return {
              tokenId: d.nftId,
              image: d.fileUrl,
              minImage: d.attributes.minImage,
              name: d.name,
              titleName: 'CAR Model',
              nftName: 'Car NFT',
              lockedCAR: carInfo.lockedCAR,
              stakingPower: carInfo.stakingPower,
              style: carInfo.style,
              size: carInfo.size,
              nftType: 103,
              level: level,
              owner: d.owner,
              maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
              ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
              ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
            }
          })
        )
        setArtworks(artworks)
        setLoadingFlag(false)
      })
    } else if (level === 'v2'){
      marketType = MARKETTYPE.CARNFT
      getArtworksV2(chainId as number, params, async(err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const artworks = await Promise.all(
          dataAry.map(async(d: any) => {
            let carInfo = {
              lockedCAR: new BigNumber(0),
              stakingPower: new BigNumber(100),
              style: '',
              size: ''
            }
            if (account) {
              carInfo = await getCarNFTInfo(getCarNFTContract(yam), d.nftId)
            }
            return {
              tokenId: d.nftId,
              image: d.fileUrl,
              minImage: d.attributes.minImage,
              name: d.name,
              titleName: 'CAR Model',
              nftName: 'Car NFT',
              lockedCAR: carInfo.lockedCAR,
              stakingPower: carInfo.stakingPower,
              style: carInfo.style,
              size: carInfo.size,
              nftType: 103,
              level: level,
              owner: d.owner,
              maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
              ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
              ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
            }
          })
        )
        setArtworks(artworks)
        setLoadingFlag(false)
      })
    }else {
      marketType = MARKETTYPEV3.CARNFTV3
      getArtworksV3(chainId as number, params, async(err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        setPageCount(Math.ceil(data.data.count / LIMIT))
        const artworks = await Promise.all(
          dataAry.map(async(d: any) => {
            let carInfo = {
              lockedCAR: new BigNumber(0),
              stakingPower: new BigNumber(100),
              style: '',
              size: ''
            }
            if (account) {
              carInfo = await getCarNFTInfo(getCarNFTContract(yam), d.nftId)
            }
            return {
              tokenId: d.nftId,
              nftId: d.nftId,
              image: d.fileUrl,
              minImage: d.attributes.minImage,
              name: d.name,
              titleName: 'CAR Model',
              nftName: 'Car NFT',
              lockedCAR: carInfo.lockedCAR,
              stakingPower: carInfo.stakingPower,
              style: carInfo.style,
              size: carInfo.size,
              nftType: 103,
              level: level,
              owner: d.owner,
              maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
              ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
              ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
            }
          })
        )
        setArtworks(artworks)
        setLoadingFlag(false)
      })
    }
  }

  const updateData = useCallback((d) => {
    setCurSelect(d)
    setPage(1)
  }, [])

  useEffect(() => {
    fetchAsksSort(page, curSelect, searchValue, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, page, curSelect, chainId, level, searchValue])

  useInterval(() => {
    fetchAsksSort(page, curSelect, searchValue)
  }, account ? 10000 : null)

  const pageHandle = useCallback((value) => {
    setPage(value)
  }, [])

  // bake balance
  // const [bakeBalance, setBakeBalance] = useState(0)
  // const bakeryBalance = useTokenBalance(getSushiAddress(yam))
  // useEffect(() => {
  //   const balance = getBalanceNumber(bakeryBalance)
  //   setBakeBalance(balance)
  // }, [yam, bakeryBalance])

  return (
    <>
      <Loading open={loadingFlag} />
      <PageHead>
        <MyEggsRow style={{justifyContent: 'flex-start'}}>
          <MyEggs to='/my-new-artworks?type=103'>
            <MiniPets src="/images/artworks/art.png" alt="" />
            <Text marginLeft={12} marginRight={12}>My CAR NFT</Text>
          </MyEggs>
        </MyEggsRow>
        <MyEggsRow style={{justifyContent: 'flex-end'}}>
          <Search value={curValue} inputChange={inputChange} searchHandle={searchHandle}></Search>
          <SortPets
            margin="0 15"
            curSelect={curSelect}
            options={SortOptions2}
            updateData={updateData}
          ></SortPets>
        </MyEggsRow>
      </PageHead>
      {
        artworks.length ? (
          <>
            <ArtworksList>
              {
                artworks.map((d, index) => {
                  return (
                    index < LIMIT ?
                      <Artworks
                        key={d.tokenId}
                        artwork={d}
                        artworklength={artworks.length}
                        type={NFTTYPE.CAR}
                        nftType={marketType}
                        isMyArtwork={false}
                        showBorder={d.size === '1' ? true : false}
                        isBlindbox={d.name === 'blindbox' ? true : false}
                        isCanTransfer={true}
                        isCanStake={false}
                        tokenName={SUPPORTTYPE.BAKE}
                        solt={<InfoSolt artwork={d} type={NFTTYPE.CAR_V3} isMyArtwork={false} />}
                      /> : ''
                  )
                })
              }
              {
                 pageCount > 1 && (
                  <Paginator pageCount={pageCount} curPage={page} page={pageHandle}></Paginator>
                )
              }
            </ArtworksList>
          </>
        ) : !loadingFlag && <NoArtworks type={NFTTYPE.CAR} status={1} />
      }
    </>
  )
}